import { cn } from "../../lib/utils";

function Skeleton({
  className,
  height,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  height?: "text-base";
}) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-black/10",
        height === "text-base" ? "h-6" : '',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
